import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import PageActions from '../AppLayout/PageActions';
import {useHistory, useLocation} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import AnswersTable from './components/AnswersTable';
import MetricSelector from './components/MetricSelector';
import ServiceTypeSelector from './components/ServiceTypeSelector';
import DateRangeSelector from './components/DateRangeSelector';
import { useDataProvider, useNotify } from 'react-admin';
import QuestionSelector from './components/QuestionSelector';

const useStyles = makeStyles(theme => ({
    title: {
        fontSize: '35px',
    },
}));

const getSelectedMetricFromUrl = (param) => {
    if (param.has('metric_id')) {
        return param.get('metric_id');
    }

    return 1;
}

const getSelectedServiceTypeFromUrl = (param) => {
    if (param.has('service_type_id')) {
        return param.get('service_type_id');
    }

    return 1;
}

const getSelectedQuestionFromUrl = (param) => {
    if (param.has('question_id')) {
        return param.get('question_id');
    }

    return null;
}

const getDateRangeStartFromUrl = (param) => {
    if (param.has('from')) {
        return param.get('from');
    }

    return null;
}

const getDateRangeEndFromUrl = (param) => {
    if (param.has('to')) {
        return param.get('to');
    }

    return null;
}

const ElevationClientAnswersV2 = () => {
    const classes = useStyles()
    const notify = useNotify()
    const dataProvider = useDataProvider()
    const history = useHistory()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)

    const [selectedMetric, setSelectedMetric] = useState(getSelectedMetricFromUrl(queryParams))
    const [selectedServiceType, setSelectedServiceType] = useState(getSelectedServiceTypeFromUrl(queryParams))
    const [selectedQuestion, setSelectedQuestion] = useState(getSelectedQuestionFromUrl(queryParams))
    const [qualifyingQuestions, setQualifyingQuestions] = useState([])
    const [showDialog, setShowDialog] = useState(false)

    const toDate = new Date()
    const fromDate = new Date()
    fromDate.setFullYear(fromDate.getFullYear() - 1)
    const [range, setRange] = useState(
        {
            from: getDateRangeStartFromUrl(queryParams) ? new Date(getDateRangeStartFromUrl(queryParams)) : fromDate,
            to: getDateRangeEndFromUrl(queryParams) ? new Date(getDateRangeEndFromUrl(queryParams)) : toDate
        }
    )

    const handleMetricChange = e => {
        setSelectedMetric(e.target.value)
        queryParams.set('metric_id', e.target.value)
        queryParams.delete('question_id')
        history.push({ search: queryParams.toString() })
        setSelectedQuestion(null)
        setQualifyingQuestions([])
        fetchQualifyingQuestions(selectedServiceType, e.target.value)
    }

    const handleServiceTypeChange = e => {
        setSelectedServiceType(e.target.value)
        queryParams.set('service_type_id', e.target.value)
        queryParams.delete('question_id')
        history.push({ search: queryParams.toString() })
        setSelectedQuestion(null)
        setQualifyingQuestions([])
        fetchQualifyingQuestions(e.target.value, selectedMetric)
    }

    const handleSelectedQuestionChange = e => {
        if (e.target.value != 0) {
            setSelectedQuestion(e.target.value)
            queryParams.set('question_id', e.target.value)
        } else {
            setSelectedQuestion(null)
            queryParams.delete('question_id')
        }

        history.push({ search: queryParams.toString() })

    }

    const handleDialogCloseClick = () => setShowDialog(false)
    const handleDialogClearClick = () => {
        setRange({ from: fromDate, to: toDate })
        setShowDialog(false)
        queryParams.set('to', toDate.toLocaleDateString('en-CA'))
        queryParams.set('from', fromDate.toLocaleDateString('en-CA'))
        history.push({ search: queryParams.toString() })
    }

    const fetchQualifyingQuestions = (serviceType, metric) => {
        const queryStringParams = {
            service_type_id: serviceType,
            metric_id: metric
        }

        dataProvider('GET_LIST', 'elevation/metric-qualifying-questions', { queryStringParams })
            .then(res => {
                setQualifyingQuestions(res.data.qualifying_questions)
            })
            .catch((e) => {
                notify(e.message, 'warning')
            })
    }

    useEffect(()=> {
        fetchQualifyingQuestions(selectedServiceType, selectedMetric)
    },[])

    return (
        <Card>
            <CardContent>
                <PageActions
                    title="Client Answers"
                    className={classes.title}
                    color={'textPrimary'}
                />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4} lg={3}>
                        <MetricSelector selectedMetric={selectedMetric} handleMetricChange={handleMetricChange} />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <ServiceTypeSelector selectedServiceType={selectedServiceType} handleServiceTypeChange={handleServiceTypeChange}/>
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <QuestionSelector selectedQuestion={selectedQuestion} questions={qualifyingQuestions} handleSelectedQuestionChange={handleSelectedQuestionChange}/>
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <DateRangeSelector
                            handleCloseClick={handleDialogCloseClick}
                            handleClearClick={handleDialogClearClick}
                            showDialog={showDialog}
                            range={range}
                            setRange={setRange}
                            setShowDialog={setShowDialog}
                            shouldSetQueryStringRange={true}
                        />
                    </Grid>
               </Grid>
                <Grid spacing={3}>
                    <Grid item xs={12}>
                        <AnswersTable
                            range={range}
                            selectedMetric={selectedMetric}
                            selectedServiceType={selectedServiceType}
                            selectedQuestion={selectedQuestion}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}


export default ElevationClientAnswersV2
